<button *ngIf="!isForMobile" (click)="onClickButton($event)" class="btn btn-primary request-btn my-2 my-sm-0" type="button"><img
  alt="plus" src="assets/images/icon-plus.svg"> {{resources?.homeMoudlue?.landingRequest?.requestBtn}}</button>

<a *ngIf="isForMobile" (click)="onClickButton($event)" class="my-2 my-sm-0" type="button">{{resources?.homeMoudlue?.landingRequest?.requestBtn}}</a>
